import { crypto as cv } from '@photo-vault/shared';

// Module-level cache of unwrapped K_album per root album. The browser tab
// keeps these in memory only; refreshing the tab forces re-unwrap from the
// server-stored wrappedAlbumKey using the in-memory rsaPriv.
const cache = new Map<string, CryptoKey>();

export async function getAlbumKey(
  rootAlbumId: string,
  wrappedAlbumKey: string,
  rsaPriv: CryptoKey,
): Promise<CryptoKey> {
  const cached = cache.get(rootAlbumId);
  if (cached) return cached;
  const key = await cv.unwrapAlbumKey(wrappedAlbumKey, rsaPriv);
  cache.set(rootAlbumId, key);
  return key;
}

export function rememberAlbumKey(rootAlbumId: string, key: CryptoKey): void {
  cache.set(rootAlbumId, key);
}

export function forgetAlbumKey(rootAlbumId: string): void {
  cache.delete(rootAlbumId);
}

export function clearAlbumKeys(): void {
  cache.clear();
}
